import { HeaderPage } from './components';
import DataTable from './components/auditLogs/DataTable';

const AuditLogsPage = () => (
  <div className='flex flex-col space-y-4 md:space-y-6 animate__animated animate__fadeIn'>
    <HeaderPage
      title="Journaux d'audit"
      description="Historique de toutes les actions effectuées sur les entités du système." />
    <DataTable />
  </div>
);

export default AuditLogsPage;
